module.exports = {
  DRAFT: 'draft',
  COMPLETED: 'completed',
  VALIDATED: 'validated',
};
